import { useLocation,Navigate } from 'react-router-dom';
import AuthContext from '../contexts/auth';
import { useContext} from 'react';
import { useSelector } from 'react-redux';

export const RoleGuardRoute = (props) => {
  const roles = useSelector((state) => state.role);
  const location = useLocation();
  const authContext = useContext(AuthContext);
  const isAuthenticated = authContext.isLoggedIn;
  if (!isAuthenticated || !props.roles || !roles?.authorities?.some(v => props?.roles?.includes(v))) {
    // user is not authenticated
    return <Navigate to='/login' state={{ from: location }} replace />;
  }
  return props.children;
};
